<div class="font-weight-light">
  {{ currentText }}
  <a class="text-green cursor-pointer" *ngIf="inlineButton" [class.d-none]="hideToggle" (click)="toggleView()"
    >{{ prependText | titlecase }} {{ isCollapsed ? "More" : "Less" }}</a
  >
</div>
<div class="cursor-pointer mt-2" [class.d-inline-flex]="!hideToggle" [class.d-none]="hideToggle" (click)="toggleView()" *ngIf="!inlineButton">
  <a class="text-green">{{ prependText | titlecase }} {{ isCollapsed ? "More" : "Less" }}</a>
  <app-rotating-caret fontSize="12" color="#009688" [rotateCaret]="!isCollapsed"> </app-rotating-caret>
</div>
